import { createFileRoute } from '@tanstack/react-router';
import { PartnerTasksPage } from '@/pages/partner/tasks/PartnerTasksPage';

export const Route = createFileRoute('/partner/tasks')({
  component: PartnerTasksPage
});
